module.exports = __webpack_public_path__ + "img/home_3.ba7068e8.png";